module.exports = "/_next/static/images/USSSGlance-237b8da23432805146ec6095809fda5b.jpg.webp";